export class UploadCoverError extends Error {
  constructor() {
    super('Não foi possível fazer o upload da capa do livro')
  }
}
